import { createConnector } from 'react-instantsearch-dom';

export default createConnector({
  displayName: 'AlgoliaGeoSearch',

  getProvidedProps() {
    return {};
  },

  refine(props, searchState, nextValue) {
    return {
      ...searchState,
      aroundLatLng: nextValue,
      boundingBox: {},
    };
  },

  getSearchParameters(searchParameters, props, searchState) {
    const currentRefinement =
      searchState.aroundLatLng || props.defaultRefinement;

      if (currentRefinement.lat == 52.3677958) {
        console.log("ip")
        return searchParameters
          //.setQueryParameter('page', 0)
          .setQueryParameter('aroundLatLngViaIP', true);
      } else {
        console.log("geo")
        return searchParameters
          //.setQueryParameter('page', 0)
          .setQueryParameter('aroundLatLngViaIP', false)
          .setQueryParameter(
            'aroundLatLng',
            `${currentRefinement.lat}, ${currentRefinement.lng}`
          );
      }

    // return searchParameters
    //   //.setQueryParameter('insideBoundingBox')
    //   //.setQueryParameter('aroundRadius', 50000)
    //   .setQueryParameter('page', 0)
    //   .setQueryParameter(
    //     'aroundLatLng',
    //     `${currentRefinement.lat}, ${currentRefinement.lng}`
    //   );

  },
});